import { cn } from '@/lib/utils';
import { sanitizeRichTextHtml } from '@/lib/richtext/sanitizeRichTextHtml';

interface RichTextRendererProps {
  html: string;
  className?: string;
}

/**
 * Safely renders rich text HTML with DOMPurify sanitization + normalization.
 * Use this for all public-facing rich text content.
 * Links automatically get rel="noopener noreferrer" for security.
 */
export function RichTextRenderer({ html, className }: RichTextRendererProps) {
  if (!html) return null;

  const safeHtml = sanitizeRichTextHtml(html);
  if (!safeHtml) return null;

  return (
    <div
      className={cn('farmly-richtext', className)}
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  );
}
